import script from "./VolvoSelektModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VolvoSelektModal.vue?vue&type=script&setup=true&lang=js"

import "./VolvoSelektModal.vue?vue&type=style&index=0&id=3731f266&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3731f266"]])

export default __exports__